import {
    EVENT_SERVICE,
    SPONSORSHIPS_SERVICE
} from './../../../providers/service.providers';
import { EventService } from '../../../services/event.service';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { Sponsorship } from '../../../models/Sponsorship';
import { LocalizableError } from 'src/app/models/LocalizableError';
import { SponsorshipsService } from 'src/app/services/sponsorships.service';
import { ImageHelper } from "src/app/helpers/ImageHelper";
import { Output, EventEmitter } from '@angular/core';

@Component({
    selector: '[app-sponsors]',
    templateUrl: './sponsors.component.html',
    styleUrls: ['./sponsors.component.scss']
})
export class SponsorsComponent implements OnInit {
    @Input() readableEventId: string;
    @Input() renderOnZeroSponsorships = true;
    @Output() sponsorsExist = new EventEmitter<any>();
    public sponsorships: Sponsorship[];
    public isLoading = false;
    public error: LocalizableError;

    public defaultImageUrl = 'default-sponsor-logo.png';
    constructor(
        private imageHelper: ImageHelper,
        @Inject(EVENT_SERVICE) private eventService: EventService,
        @Inject(SPONSORSHIPS_SERVICE) private sponsorsService: SponsorshipsService,
    ) {}

    ngOnInit() {
        this.loadSponsors();
    }

    private loadSponsors() {
        this.isLoading = true;
        this.eventService.getSponsors(this.readableEventId).subscribe(
            sponsorships => {
                this.sponsorships = sponsorships;
                this.sponsorships.sort((a,b) => (a.sponsorshipTopic > b.sponsorshipTopic) ? 1 : ((b.sponsorshipTopic > a.sponsorshipTopic) ? -1 : 0))
                this.setSponsorLogosSrc();
                // console.log("SponsorShip :-", sponsorships);
                this.sponsorsExist.emit(sponsorships);
                
                this.isLoading = false;
            },
            (error: LocalizableError) => this.handleErrorResponse(error)
        );
    }

    private setSponsorLogosSrc() {
        this.sponsorships.forEach(sponsor => {
            sponsor.logoSrc = this.sponsorsService.getLogoSrc(sponsor);
        });
    }

    private handleErrorResponse(error: LocalizableError) {
        this.isLoading = false;
        this.error = error;
    }
}
